import { DiffMode, ViewIds } from '@ardoq/api-types';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { workspaceModeSettingsForAllViews$ } from 'views/environmentals/viewSettings/workspaceModeViewSettings$';

export const activeDiffMode$: Observable<DiffMode> =
  workspaceModeSettingsForAllViews$.pipe(
    map(
      ({ currentSettings }) =>
        currentSettings[ViewIds.BLOCK_DIAGRAM].activeDiffMode
    ),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

let currentActiveDiffMode: DiffMode = DiffMode.MAIN;

activeDiffMode$.subscribe(
  activeDiffMode => (currentActiveDiffMode = activeDiffMode)
);

export const getActiveDiffMode = () => currentActiveDiffMode;
